var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.3,
    height: 58.301,
    viewBox: "0 0 58.3 58.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_57",
    "data-name": "Komponente 10 \\u2013 57",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lactose-free"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46735",
    "data-name": "Pfad 46735",
    d: "M55.808,151.838A25.446,25.446,0,0,0,71.67,146.3a1.861,1.861,0,0,0,.155-2.771L67.4,139.109,47.736,119.445h0l-9.212-9.212a1.861,1.861,0,0,0-2.771.154,25.578,25.578,0,0,0,20.056,41.451Zm10.141-11.777v1.028a1.758,1.758,0,0,1-1.756,1.756H47.4a1.76,1.76,0,0,1-1.756-1.756V128.94a4.293,4.293,0,0,0,3.965-1.228,4.295,4.295,0,0,0,4.909.916ZM53.172,127.285a2.58,2.58,0,0,1-2.421-.837,1.522,1.522,0,0,0-2.291,0,2.59,2.59,0,0,1-2.82.731v-.9a8.679,8.679,0,0,1,1.575-4.948ZM37.083,111.444a.16.16,0,0,1,.238-.01L46,120.112a10.394,10.394,0,0,0-2.058,6.164V141.09h0a3.459,3.459,0,0,0,3.455,3.455h16.8a3.46,3.46,0,0,0,3.4-2.84l3.03,3.03a.16.16,0,0,1-.01.238,23.869,23.869,0,0,1-33.53-33.53Z",
    transform: "translate(-26.795 -97.262)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46736",
    "data-name": "Pfad 46736",
    d: "M143.533,71.633a1.861,1.861,0,0,0,2.771-.155,25.415,25.415,0,0,0,5.442-13.824.85.85,0,1,0-1.694-.136,23.721,23.721,0,0,1-5.079,12.9.16.16,0,0,1-.238.01l-6.62-6.62V55.619a10.509,10.509,0,0,0-4.037-8.219c-1.2-.955-1.857-2.572-1.975-4.81a2.688,2.688,0,0,0-.749-5.27h-3.11a.85.85,0,1,0,0,1.7h3.11a.989.989,0,0,1,0,1.978H121.168a.989.989,0,0,1,0-1.978h3.11a.85.85,0,1,0,0-1.7h-3.11a2.688,2.688,0,0,0-.748,5.27,8.785,8.785,0,0,1-.6,2.924l-8.384-8.384a.16.16,0,0,1,.01-.238c15.011-11.919,37.1-2.047,38.608,16.8a.85.85,0,0,0,1.694-.135c-1.617-20.227-25.3-30.741-41.358-17.992a1.861,1.861,0,0,0-.155,2.771Zm-7.118-9.521-4.551-4.551a4.318,4.318,0,0,0,.585-.508,4.293,4.293,0,0,0,3.965,1.228ZM122.116,42.7h8.289c.147,2.736,1.024,4.763,2.612,6.031a8.819,8.819,0,0,1,3.4,6.891v.9a2.59,2.59,0,0,1-2.82-.731,1.522,1.522,0,0,0-2.291,0,2.605,2.605,0,0,1-.668.544l-9.544-9.544A9.808,9.808,0,0,0,122.116,42.7Z",
    transform: "translate(-97.261 -26.604)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46737",
    "data-name": "Pfad 46737",
    d: "M29,58A29,29,0,1,0,0,29,28.984,28.984,0,0,0,29,58ZM29,1.7A27.3,27.3,0,1,1,1.7,29,27.332,27.332,0,0,1,29,1.7Z",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.0d3a24529a91f4ed921159a5b219c1d2.svg";
export { ForwardRef as ReactComponent };